import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabbedScrollerService {
  private moveToPlanSectionSubject = new BehaviorSubject<boolean>(false);
  moveToPlanSection$ = this.moveToPlanSectionSubject.asObservable();

  moveToPlanSection(show) {
    this.moveToPlanSectionSubject.next(show);
  }
}
